document.addEventListener("DOMContentLoaded", () => {
  const hero = document.getElementById("slider");
  const track = hero.querySelector(".hero__slider-container");
  const nextBtn = hero.querySelector(".hero-right-arrow");
  const prevBtn = hero.querySelector(".hero-left-arrow");
  const slides = hero.querySelectorAll(".hero__slider-item");

  const isMobile = window.matchMedia("(max-width: 999px)").matches;
  let isAnimating = false;
  let dragged = false;
  let currentIndex = parseInt(track.dataset.start);
  let maxMoves = parseInt(track.dataset.count);

  let viewportWidth = hero.offsetWidth;
  let slideWidth = slides[0].offsetWidth;
  let centerOffset = viewportWidth / 2 - slideWidth / 2;

  const updateNav = () => {
    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex === maxMoves - 1;
  };

  if (nextBtn && prevBtn) {
    nextBtn.addEventListener("click", () => {
      if (currentIndex < maxMoves - 1) {
        currentIndex++;
        updateSlides(currentIndex);
        updateTrack(currentIndex);
        updateNav();
      }
      return;
    });
    prevBtn.addEventListener("click", () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlides(currentIndex);
        updateTrack(currentIndex);
        updateNav();
      }
      return;
    });
  }

  // Update Slides Stats
  const updateSlides = (index, animate = true) => {
    slides.forEach((slide) => {
      const slideIndex = parseInt(slide.dataset.index);
      slide.classList.remove("next", "prev", "active", "to-left", "to-right");
      if (!animate) {
        slide.style.transition = "none";
      } else {
        slide.style.transition = "transform 1s ease";
      }

      switch (true) {
        case slideIndex === index:
          slide.classList.add("active");
          break;
        case slideIndex === index - 1:
          slide.classList.add("prev");
          break;
        case slideIndex === index + 1:
          slide.classList.add("next");
          break;
        case slideIndex < index - 1:
          slide.classList.add("to-left");
          break;
        case slideIndex > index + 1:
          slide.classList.add("to-right");
          break;
      }
    });
  };

  const updateTrack = (index, animate = true) => {
    const translateX = -index * slideWidth + centerOffset;

    if (animate) {
      hero.classList.add("is-animating");
      isAnimating = true;

      // Enable smooth transition
      track.style.transition = "transform 1s ease";
      track.style.transform = `translateX(${translateX}px)`;

      setTimeout(() => {
        hero.classList.remove("is-animating");
        isAnimating = false;
      }, 1000);
    } else {
      // Instantly reset — no delay, no flicker
      track.style.transition = "none";
      track.style.transform = `translateX(${translateX}px)`;

      hero.classList.remove("is-animating");
      isAnimating = false;
    }
  };

  let startX = 0;
  let startY = 0;
  let isDragging = false;
  let dragDiff = 0;
  let maxDragDistance = 0; // Track maximum drag distance during interaction
  let wasDragging = false; // Flag to track if dragging occurred (for link click prevention)
  const CLICK_THRESHOLD = 8; // Pixels threshold for click vs drag

  // Prevent default image dragging
  hero.querySelectorAll("img").forEach((img) => {
    img.addEventListener("dragstart", (e) => e.preventDefault());
  });

  const dragStart = (e) => {
    if (isAnimating) return;
    dragged = false;
    isDragging = true;
    wasDragging = false; // Reset drag flag
    maxDragDistance = 0; // Reset max drag distance

    if (e.type && e.type.startsWith("touch")) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    } else {
      startX = e.clientX;
      startY = e.clientY;
    }

    dragDiff = 0;
    e.preventDefault();
  };

  // later, in dragMove:
  const dragMove = (e) => {
    if (!isDragging) return;

    // get coordinates (handle touch & mouse safely)
    const isTouch = e.type && e.type.startsWith("touch");
    const x = isTouch ? e.touches[0] && e.touches[0].clientX : e.clientX;
    const y = isTouch ? e.touches[0] && e.touches[0].clientY : e.clientY;

    // defensive: if we don't have a y yet, bail
    if (typeof startY !== "number") startY = y || 0;

    dragDiff = x - startX;
    const verticalDiff = Math.abs(y - startY);

    // Track maximum drag distance
    const currentDragDistance = Math.abs(dragDiff);
    if (currentDragDistance > maxDragDistance) {
      maxDragDistance = currentDragDistance;
    }

    // only block default when it's a clear horizontal drag
    if (Math.abs(dragDiff) > 6 && verticalDiff < 10) {
      // IMPORTANT: touchmove must be registered with passive:false for this to work
      if (e.cancelable) e.preventDefault();
      dragged = true;
    }
  };

  const dragEnd = () => {
    if (!isDragging || isAnimating) {
      // Reset even if not dragging to clear state
      if (!isDragging) {
        maxDragDistance = 0;
        wasDragging = false;
      }
      return;
    }

    // Set flag if drag distance exceeded threshold
    wasDragging = maxDragDistance >= CLICK_THRESHOLD;
    isDragging = false;

    if (dragDiff > 20 && currentIndex > 0) {
      currentIndex--;
      updateSlides(currentIndex);
      updateTrack(currentIndex, true);
      updateNav();
    } else if (dragDiff < -20 && currentIndex < maxMoves - 1) {
      currentIndex++;
      updateSlides(currentIndex);
      updateTrack(currentIndex, true);
      updateNav();
    } else {
      updateTrack(currentIndex, false);
    }

    // Reset drag state after a short delay to allow click handlers to check
    setTimeout(() => {
      dragDiff = 0;
      maxDragDistance = 0;
      wasDragging = false;
    }, 150);
  };

  track.addEventListener("mousedown", dragStart);
  track.addEventListener("touchstart", dragStart, { passive: true });

  track.addEventListener("mousemove", dragMove);
  track.addEventListener("touchmove", dragMove, { passive: false });

  track.addEventListener("mouseup", dragEnd);
  track.addEventListener("mouseleave", dragEnd);
  track.addEventListener("touchend", dragEnd, { passive: true });

  // Prevent link clicks if user was dragging (>= 8px threshold)
  const links = track.querySelectorAll("a");
  links.forEach((link) => {
    link.addEventListener(
      "click",
      (e) => {
        // If drag distance was >= threshold, prevent link navigation
        if (wasDragging || maxDragDistance >= CLICK_THRESHOLD) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      },
      true
    ); // Use capture phase to catch before default behavior
  });

  updateSlides(currentIndex);
  updateTrack(currentIndex, false);
  updateNav();

  // 🧭 ResizeObserver with debounce to re-center slider on resize
  let resizeTimeout;

  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      viewportWidth = hero.offsetWidth;
      slideWidth = slides[0].offsetWidth;
      centerOffset = viewportWidth / 2 - slideWidth / 2;

      // Update global offset and reposition track
      updateSlides(currentIndex, false);
      updateTrack(currentIndex, false);
    }, 200);
  };

  const resizeObserver = new ResizeObserver(handleResize);
  resizeObserver.observe(hero);

  // 🎬 Hero Loading Animation
  const heroTl = gsap.timeline({ duration: 0.6, ease: "power2.out" });

  const left = document.querySelector(".showcase__left");
  const middleBoxes = document.querySelectorAll(".middle-box");
  const right = document.querySelector(".showcase__right");
  const header = document.querySelector(".main-header");

  heroTl
    .from(middleBoxes, {
      opacity: 0,
      stagger: { from: "center", each: 0.1 },
      ease: "power1.out",
      duration: 0.6,
    })
    .from(left, { opacity: 0, y: 20 }, "<=0.3")
    .from(right, { opacity: 0, y: 20 }, "<=0.15")
    .fromTo(
      header,
      { opacity: 0, y: -100, duration: 0.3 },
      { opacity: 1, y: 0, duration: 0.3 },
      "-=0.6"
    );

  heroTl.eventCallback("onComplete", () => {
    header.style.transition = "all 0.3s ease";
  });

  const heroSection = document.querySelector("#hero");
  const flaggedBox = heroSection.querySelector('[data-flagged="true"] img');
  const receiveWrapper = heroSection.querySelector('[data-receive="true"] img');

  if (!flaggedBox || !receiveWrapper) return;

  gsap.set(receiveWrapper, { opacity: 0 });

  // Helper: create a faithful placeholder that preserves layout & transforms
  function createFaithfulPlaceholder(origEl, sourceRect) {
    const computed = getComputedStyle(origEl);
    const ph = origEl.cloneNode(false);

    // remove any image data if it's an <img>
    ph.removeAttribute && ph.removeAttribute("src");
    ph.removeAttribute && ph.removeAttribute("srcset");

    // Keep layout (not display:none) so flexbox sizing is preserved
    ph.style.visibility = "hidden";
    ph.style.display = computed.display;
    ph.style.width = `${sourceRect.width}px`;
    ph.style.height = `${sourceRect.height}px`;
    ph.style.margin = computed.margin;
    ph.style.padding = computed.padding;
    ph.style.boxSizing = computed.boxSizing;
    ph.style.transform = computed.transform; // keeps scale(1.5) from parent or itself
    ph.style.transformOrigin = computed.transformOrigin;
    ph.style.objectFit = computed.objectFit || "cover";
    ph.style.alignSelf = computed.alignSelf || "";
    ph.style.pointerEvents = "none";

    return ph;
  }

  const card = receiveWrapper.closest(".card-product");

  // Helper to disable pointer/hover events on product cards
  function disableProductCardHover() {
    card.classList.add("no-hover");
  }

  // Helper to re-enable them
  function enableProductCardHover() {
    card.classList.remove("no-hover");
  }

  // lock scroll safely (prevent user interaction)
  function preventScroll(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
  function lockScroll() {
    window.addEventListener("wheel", preventScroll, { passive: false });
    window.addEventListener("touchmove", preventScroll, { passive: false });
    window.addEventListener("keydown", preventScroll, { passive: false });
  }
  function unlockScroll() {
    window.removeEventListener("wheel", preventScroll);
    window.removeEventListener("touchmove", preventScroll);
    window.removeEventListener("keydown", preventScroll);
  }

  // 💨 UNIVERSAL INSTANT + SMOOTH SCROLL (cross-device, no delay)
  function smoothScrollTo(y, duration = 1.2, ease = "power2.inOut") {
    const targetY = Math.max(0, y);
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // Ensure native smooth scrolling doesn't fight the tween
    const root = document.documentElement;
    const prevBehavior = root.style.scrollBehavior || "";

    root.style.scrollBehavior = "auto";

    // Start a GSAP-driven smooth scroll from current position
    return gsap.to(window, {
      scrollTo: { y: targetY - 100, autoKill: false },
      duration: duration,
      ease,
      overwrite: "auto",
      immediateRender: true,
      onComplete: () => {
        root.style.scrollBehavior = prevBehavior;
      },
    });
  }

  // Revised animateHeroFlip - robust and handles "scroll-to-source then scroll-to-target"
  async function animateHeroFlip(sourceImg, targetImg) {
    // 1) measure current geometry (viewport-based rects)
    const srcRect = sourceImg.getBoundingClientRect();
    const tgtRect = targetImg.getBoundingClientRect();

    // convert to absolute document coordinates
    const scrollY = window.scrollY || window.pageYOffset;
    const scrollX = window.scrollX || window.pageXOffset;
    const sourceAbsTop = srcRect.top + scrollY;
    const sourceAbsLeft = srcRect.left + scrollX;
    const sourceWidth = srcRect.width;
    const sourceHeight = srcRect.height;

    // create a faithful placeholder that preserves layout and transforms
    const placeholder = createFaithfulPlaceholder(sourceImg, srcRect);
    sourceImg.parentNode.replaceChild(placeholder, sourceImg);

    // Put the real image into document space so it moves with page scroll
    document.body.appendChild(sourceImg);
    Object.assign(sourceImg.style, {
      position: "absolute", // document-space so it follows scrolling
      top: `${sourceAbsTop}px`,
      left: `${sourceAbsLeft}px`,
      width: `${sourceWidth}px`,
      height: `${sourceHeight}px`,
      margin: "0",
      objectFit: "contain",
      zIndex: 99,
      pointerEvents: "none",
      transformOrigin: "center center",
    });

    // GPU hint
    sourceImg.style.willChange = "top, left, width, height, transform";
    targetImg.style.willChange = "opacity";

    // Build timeline
    const tl = gsap.timeline({
      defaults: { ease: "power2.inOut" },
    });

    // 2) Step A: bring the viewport to the source (so animation always starts from visible source)
    // 🔹 Lock scroll immediately before animation
    lockScroll();
    disableProductCardHover();

    document.body.offsetHeight;
    // 🔹 Force layout sync before measuring target
    await Promise.resolve();

    // 3) Re-measure target geometry after viewport moved (IMPORTANT for accuracy)
    const freshTgtRect = targetImg.getBoundingClientRect();
    const freshTgtTop =
      freshTgtRect.top + (window.scrollY || window.pageYOffset);
    const freshTgtLeft =
      freshTgtRect.left + (window.scrollX || window.pageXOffset);

    // 4) Create the main animation: simultaneous page scroll to target and image morph to target box
    const targetOffsetPx = Math.round(Math.min(120, window.innerHeight * 0.25));

    gsap.set(targetImg, { opacity: 0 });

    const mainTL = gsap.timeline({
      defaults: { ease: "power3.inOut" },
      onComplete: () => {
        gsap.set(targetImg, { opacity: 1 });
        gsap.set(sourceImg, { clearProps: "all" });
        placeholder.parentNode.replaceChild(sourceImg, placeholder);
        unlockScroll();
        enableProductCardHover();
      },
    });

    // 🔹 Combined smooth scroll + morph
    mainTL.add(smoothScrollTo(freshTgtTop - targetOffsetPx, 1.4), 0);

    mainTL.to(
      sourceImg,
      {
        top: freshTgtTop,
        left: freshTgtLeft,
        width: freshTgtRect.width,
        height: freshTgtRect.height,
        scale: 1,
        duration: 1.4,
      },
      0
    );

    mainTL.to(
      targetImg,
      {
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
      },
      "-=0.4"
    );

    await mainTL.then();
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      const entry = entries[0];
      if (!entry.isIntersecting) {
        // 🧭 Reset slider before re-running animation
        currentIndex = parseInt(track.dataset.start);

        updateSlides(currentIndex, false);
        updateTrack(currentIndex, false);
        updateNav();

        // ✅ Run the animation only if not in Shopify customize mode
        if (!window.Shopify?.designMode) {
          animateHeroFlip(flaggedBox, receiveWrapper);
        }
      }
    },
    {
      root: null,
      threshold: 0,
      rootMargin: "-90% 0px 0px  0px",
    }
  );

  observer.observe(showcase);
});
